<template>
  <div class="section register">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-half">
          <template v-if="!submitted">
            <div class="section-block">
              <span class="title">JOIN THE STUDENT MOVEMENT</span>
            </div>
            <validation-observer
              @submit.prevent="submit"
              tag="form"
              ref="register"
              v-slot="{ valid }"
            >
              <validation-provider
                vid="first_name"
                rules="required"
                name="first name"
                v-slot="{ errors }"
              >
                <b-field
                  :message="errors"
                  :type="{ 'is-danger': errors.length }"
                >
                  <b-input
                    v-model="form.first_name"
                    placeholder="First name"
                  ></b-input>
                </b-field>
              </validation-provider>
              <validation-provider
                vid="last_name"
                rules="required"
                name="last name"
                v-slot="{ errors }"
              >
                <b-field
                  :message="errors"
                  :type="{ 'is-danger': errors.length }"
                >
                  <b-input
                    v-model="form.last_name"
                    placeholder="Last name"
                  ></b-input>
                </b-field>
              </validation-provider>
              <validation-provider
                rules="required|email"
                name="email"
                v-slot="{ errors }"
              >
                <b-field
                  :message="errors"
                  :type="{ 'is-danger': errors.length }"
                >
                  <b-input
                    v-model="form.email"
                    placeholder="Email address"
                    type="email"
                  ></b-input>
                </b-field>
              </validation-provider>
              <validation-provider
                vid="phone_number"
                rules="required"
                name="phone number"
                v-slot="{ errors }"
              >
                <b-field
                  :message="errors"
                  :type="{ 'is-danger': errors.length }"
                >
                  <b-input
                    v-model="form.phone_number"
                    placeholder="Phone number"
                  ></b-input>
                </b-field>
              </validation-provider>
              <validation-provider vid="address" v-slot="{ errors }">
                <b-field
                  :message="errors"
                  :type="{ 'is-danger': errors.length }"
                >
                  <b-input
                    v-model="form.address"
                    placeholder="Address (optional)"
                  ></b-input>
                </b-field>
              </validation-provider>
              <validation-provider
                vid="school"
                rules="required"
                name="school or ministry"
                v-slot="{ errors }"
              >
                <b-field
                  :message="errors"
                  :type="{ 'is-danger': errors.length }"
                >
                  <b-input v-model="form.school" placeholder="School"></b-input>
                </b-field>
              </validation-provider>
              <validation-provider
                vid="year_level"
                name="year level"
                v-slot="{ errors }"
              >
                <b-field
                  :message="errors"
                  :type="{ 'is-danger': errors.length }"
                >
                  <b-input
                    v-model="form.year_level"
                    placeholder="Year Level (optional)"
                  ></b-input>
                </b-field>
              </validation-provider>
              <validation-provider
                vid="group"
                name="church or youth group"
                v-slot="{ errors }"
              >
                <b-field
                  :message="errors"
                  :type="{ 'is-danger': errors.length }"
                >
                  <b-input
                    v-model="form.group"
                    placeholder="Church/Youth Group (optional)"
                  ></b-input>
                </b-field>
              </validation-provider>

              <div class="section-block no-border">
                <span class="title is-size-5"
                  >I am currently part of a Christian Lunchtime Group at
                  school</span
                >
              </div>

              <validation-provider
                vid="in_group"
                rules="required"
                name="is part of group"
                v-slot="{ errors }"
              >
                <b-field
                  :message="errors"
                  :type="{ 'is-danger': errors.length }"
                >
                  <div class="block">
                    <b-radio v-model="form.part_in_ltg" :native-value="true">
                      Yes
                    </b-radio>
                    <b-radio v-model="form.part_in_ltg" :native-value="false">
                      Not yet
                    </b-radio>
                  </div>
                </b-field>
              </validation-provider>

              <div class="section-block no-border">
                <span class="title is-size-5"
                  >Referee (Parent/Youth Pastor/School Chaplain/Group
                  Leader)</span
                >
              </div>

              <validation-provider
                vid="referee.name"
                rules="required"
                name="referee name"
                v-slot="{ errors }"
              >
                <b-field
                  :message="errors"
                  :type="{ 'is-danger': errors.length }"
                >
                  <b-input
                    v-model="form.referee.name"
                    placeholder="Full name"
                  ></b-input>
                </b-field>
              </validation-provider>
              <validation-provider
                vid="referee.contact"
                rules="required"
                name="referee contact information"
                v-slot="{ errors }"
              >
                <b-field
                  :message="errors"
                  :type="{ 'is-danger': errors.length }"
                >
                  <b-input
                    v-model="form.referee.contact"
                    placeholder="Contact (Phone/Email)"
                  ></b-input>
                </b-field>
              </validation-provider>
              <validation-provider
                vid="referee.relationship"
                rules="required"
                name="relationship"
                v-slot="{ errors }"
              >
                <b-field
                  :message="errors"
                  :type="{ 'is-danger': errors.length }"
                >
                  <b-input
                    v-model="form.referee.relationship"
                    placeholder="Relationship"
                  ></b-input>
                </b-field>
              </validation-provider>

              <div class="section-block no-border">
                <span class="title is-size-5">Message</span>
              </div>

              <validation-provider
                vid="message"
                rules="max:255"
                name="message"
                v-slot="{ errors }"
              >
                <b-field
                  :message="errors"
                  :type="{ 'is-danger': errors.length }"
                >
                  <b-input
                    v-model="form.message"
                    type="textarea"
                    placeholder="Message (optional)"
                  ></b-input>
                </b-field>
              </validation-provider>

              <b-button
                :disabled="!valid || isSubmitting"
                native-type="submit"
                :loading="isSubmitting"
                class="is-pulled-right"
                type="is-primary"
                >Submit</b-button
              >
            </validation-observer>
          </template>
          <!-- When registration is submitted successfully -->
          <template v-else>
            <div class="section-block">
              <span class="title">REGISTRATION SENT</span>
            </div>
            <div class="success-message is-size-5">
              <p>Hi there!</p>
              <br />
              <p>
                Thanks for signing up to the Student Movement. We are currently
                processing your registration. We may give you or your referee a
                call just to confirm you are not a robot.
              </p>
              <br />
              <p>
                When that’s done, be on the lookout for an email saying you are
                ready to complete your profile and start connecting with others.
              </p>
              <br />
              <p>
                In the meantime, you can read up on our Community Guidelines
                below. It’s short, sharp and simple, and it helps make sure
                everyone can interact in a safe and respectful environment.
              </p>
              <div class="download">
                <a
                  class="button is-button-download is-rounded"
                  href="/files/CommunityGuidelines_Feb_2020.pdf"
                  target="_blank"
                >
                  Community-guidelines.pdf
                </a>
              </div>
              <p>
                If you have any questions or concerns, please message us through
                any of our social media sites above.
              </p>
            </div>
            <router-link class="button is-primary" :to="{ name: 'home' }"
              >Back to home page</router-link
            >
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserInquiry from '@/models/UserInquiry'

export default {
  metaInfo: {
    title: 'Create account'
  },
  data() {
    return {
      isSubmitting: false,
      submitted: false,
      form: {
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        address: '',
        school: '',
        year_level: '',
        group: '',
        part_in_ltg: false,
        message: '',
        referee: {
          name: '',
          contact: '',
          relationship: ''
        }
      }
    }
  },
  methods: {
    submit() {
      this.isSubmitting = true
      const userInquiry = new UserInquiry(this.form)

      userInquiry
        .save()
        .then(() => {
          this.submitted = true
          this.form = {
            first_name: '',
            last_name: '',
            email: '',
            phone_number: '',
            address: '',
            school: '',
            year_level: '',
            group: '',
            part_in_ltg: false,
            message: '',
            referee: {
              name: '',
              contact: ''
            }
          }

          requestAnimationFrame(() => {
            this.$refs.register.reset()
          })
        })
        .catch(({ response }) => {
          if (response.data && response.data.errors) {
            this.$refs.register.setErrors(response.data.errors)
          }
        })
        .then(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>
